import { watchForDisableMFAAction } from './disableMFA';
import { getUserPermissions } from './fetch_permissions';
import { watchForRefreshPreferredMFAAction } from './refreshPreferredMFA';
import { watchForAmplifySignIn } from './signIn';
import { watchForSignOut } from './signOut';

export const Sagas = [
  getUserPermissions(),
  watchForAmplifySignIn,
  watchForDisableMFAAction,
  watchForRefreshPreferredMFAAction,
  watchForSignOut,
];
